import { Container } from '@react-email/container';

import React, { Component } from 'react';
import ImageBlock from './imageBlock';
import { Column } from '@react-email/column';
import TestTextBlock from './textBlock';
import { Section } from '@react-email/section';
import { connect } from 'react-redux';
import { putElm, setArr } from '../../../actions/actions';
import Menu from '../../../components/Menu';

import { bindActionCreators } from 'redux';
import { Row } from '@react-email/row';
import generateBlock from './generateBlock';

class LogoAIBlock extends Component {

    constructor(props) {
        super(props);
        this.types = ['ai-logo-1', 'ai-logo-2', 'ai-logo-3', 'ai-logo-4', 'ai-logo-5', 'ai-logo-6'];
        this.state = {

        };
    }

    getImg1 = () => {

        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img1) {
                return generateBlock(arr[i]);
            }
        }
    }
    getImg1Width = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img1) {
                return (arr[i].params.width);
            }
        }

    }

    getImg2 = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img2) {
                return generateBlock(arr[i]);
            }
        }
    }
    getImg2Width = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img2) {
                return (arr[i].params.width);
            }
        }
    }
    getImg3 = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img3) {
                return generateBlock(arr[i]);
            }
        }
    }
    getImg3Width = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img3) {
                return (arr[i].params.width);
            }
        }
    }
    getMarginTop = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.marginTop;
            }
        }
    }
    getMarginLeft = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.marginLeft;
            }
        }
    }
    getMarginRight = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.marginRight;
            }
        }
    }
    getMarginBottom = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.marginBottom;
            }
        }
    }
    getPaddingTop = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.paddingTop;
            }
        }
    }
    getPaddingLeft = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.paddingLeft;
            }
        }
    }
    getPaddingRight = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.paddingRight;
            }
        }
    }
    getPaddingBottom = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.paddingBottom;
            }
        }
    }
    getBackgroundColor = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].params.backgroundColor;
            }
        }
    }

    checkIfCanInteract = () => {
        return this.props.arr.filter(item => item.id === this.props.id)[0].params.for === -99;
    }

    editBlock = () => {
        this.props.putElm({ id: this.props.id, type: this.props.type })
    }

    deleteBlock = () => {
        const deletedBlock = this.props.arr.filter(item => item.id === this.props.id);
        const childrens = deletedBlock[0].childrens;
        if (deletedBlock[0].params.for !== -99) return;
        this.props.setArr(this.props.arr.filter(item => item.id !== this.props.id).filter(item => {
            if (!childrens.includes(item.id)) {
                return item
            }
        }));
    }

    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    copyBlock = () => {
        let id = this.uuidv4();
        const block = this.props.arr.filter(item => item.id === this.props.id);
        const blockChildrens = this.props.arr.filter(item => item.params.for === block[0].id);
        const modifiedblockChildrens = blockChildrens.map(item => {
            return { ...item, id: this.uuidv4(), params: { ...item.params, for: id } }
        })
        let childrens = [];
        modifiedblockChildrens.forEach(item => childrens.push(item.id))
        const modifiedBlock = structuredClone(block.map(item => {
            return { ...item, id: id, childrens: [...childrens] }
        }))
        const res = [...modifiedblockChildrens, ...modifiedBlock];
        this.props.arr.push(...res);
        var arr = Array.prototype.concat(this.props.arr);
        this.props.setArr(arr);
    }

    elemMove = (direction) => {
        let arr = this.props.arr.filter(elem => elem.params.for === -99);
        let arrWithout99 = this.props.arr.filter(elem => elem.params.for !== -99);
        let selectedElemIndex = 0;
        let selectedElem = arr.find((elem, index) => {
            selectedElemIndex = index;
            return elem.id === this.props.id
        });
        let res = [];
        if (direction === 'up') {
            if (selectedElemIndex === 0) return;
            const arrCopy = [...arr];
            let element = arrCopy[selectedElemIndex];
            arrCopy.splice(selectedElemIndex, 1);
            arrCopy.splice(selectedElemIndex - 1, 0, element);
            res = arrCopy;
        }
        if (direction === 'down') {
            if (selectedElemIndex === this.props.arr.length - 1) return;
            const arrCopy = [...arr];
            let element = arrCopy[selectedElemIndex];
            arrCopy.splice(selectedElemIndex, 1);
            arrCopy.splice(selectedElemIndex + 1, 0, element);
            res = arrCopy;
        }
        this.props.setArr(res.concat(arrWithout99));
    }

    componentDidMount = () => {
        document.querySelectorAll('#moved-block')[0].classList.add('menu-moveBottom');

        var arr = JSON.parse(JSON.stringify(this.props.arr));
        arr = this.switchAlign(this.getType(), arr);
        this.props.setArr(arr);
    }

    componentWillUnmount = () => {
        document.querySelectorAll('#moved-block')[0].classList.remove('menu-moveBottom')
    }

    getType = () => {
        var arr = this.props.arr;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == this.props.id) {
                return arr[i].type;
            }
        }
    }

    renderBlock = (type) => {

        switch (type) {
            case 'ai-logo-1':
                return <>
                    <Column style={{ width: this.getImg1Width() }}>{this.getImg1()}</Column>
                    <Column style={{ width: this.getImg2Width() }}>{this.getImg2()}</Column>
                    <Column>{this.getImg3()}</Column>
                </>;
                break;
            case 'ai-logo-2':
                return <>
                    <Column style={{ width: this.getImg1Width() }}>{this.getImg1()}</Column>
                </>
                break;
            case 'ai-logo-3':
                return <>
                    <Column>{this.getImg1()}</Column>
                    <Column style={{ width: this.getImg2Width() }}>{this.getImg2()}</Column>
                    <Column style={{ width: this.getImg3Width() }} align='right'>{this.getImg3()}</Column>
                </>;
                break;
            case 'ai-logo-4':
                return <>
                    <Column>{this.getImg1()}</Column>
                </>;
                break;
            case 'ai-logo-5':
                return <>
                    <Column style={{ width: this.getImg3Width() }}>{this.getImg3()}</Column>
                </>
                break;
            case 'ai-logo-6':
                return <>
                    <Column>{this.getImg3()}</Column>
                </>
                break;
            default:
                break;
        }
        return <h3>{type}</h3>;
    }

    styleBack = () => {
        let type = this.getType();
        let num = parseInt(type.replace('ai-logo-', ''));
        if (num <= 1) {
            return;
        } else {
            num--;
            type = 'ai-logo-' + num.toString();
            var arr = JSON.parse(JSON.stringify(this.props.arr));
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id == this.props.id) {
                    arr[i].type = type;
                    arr = this.switchAlign(type, arr);
                    this.props.setArr(arr);

                }
            }
        }
    }
    styleForward = () => {
        let type = this.getType();
        let num = parseInt(type.replace('ai-logo-', ''));
        if (num >= this.types.length) {
            return;
        } else {
            num++;
            type = 'ai-logo-' + num.toString();

            var arr = JSON.parse(JSON.stringify(this.props.arr));
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].id == this.props.id) {
                    arr[i].type = type;
                    arr = this.switchAlign(type, arr);
                    this.props.setArr(arr);

                }
            }
        }
    }
    setImg1Align = (align, arr) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img1) {
                arr[i].params.align = align;
                return arr;
            }
        }
    }
    setImg2Align = (align, arr) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img2) {
                arr[i].params.align = align;
                return arr;
            }
        }
    }
    setImg3Align = (align, arr, padding) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === this.props.img3) {
                arr[i].params.align = align;
                arr[i].params.paddingTop = padding.split(',')[0];
                arr[i].params.paddingBottom = padding.split(',')[2];
                return arr;
            }
        }
    }
    switchAlign = (type, arr) => {

        switch (type) {
            case 'ai-logo-1':
                arr = this.setImg1Align('left', arr);
                arr = this.setImg2Align('left', arr);
                arr = this.setImg3Align('left', arr, '0px,0px,0px,0px');
                break;
            case 'ai-logo-2':
                arr = this.setImg1Align('left', arr);
                arr = this.setImg2Align('left', arr);
                arr = this.setImg3Align('left', arr, '0px,0px,0px,0px');

                break;
            case 'ai-logo-3':
                arr = this.setImg1Align('right', arr);
                arr = this.setImg2Align('right', arr);
                arr = this.setImg3Align('right', arr, '0px,0px,0px,0px');

                break;
            case 'ai-logo-4':
                arr = this.setImg1Align('right', arr);
                arr = this.setImg2Align('right', arr);
                arr = this.setImg3Align('right', arr, '0px,0px,0px,0px');

                break;
            case 'ai-logo-5':
                arr = this.setImg1Align('left', arr);
                arr = this.setImg2Align('left', arr);
                arr = this.setImg3Align('left', arr, '20px,0px,20px,0px');
                break;
            case 'ai-logo-6':
                arr = this.setImg1Align('right', arr);
                arr = this.setImg2Align('right', arr);
                arr = this.setImg3Align('right', arr, '20px,0px,20px,0px');
                break;
            default:
                break;
        }
        return arr;
    }
    render() {
        return (
            <Row
                name={this.props.id} onMouseEnter={(e) => {
                    var btns = document.getElementsByName(this.props.id)[0].getElementsByClassName('change-buttonts')[0];
                    btns.style.visibility = '';
                    btns.style.opacity = 1;
                }} onMouseLeave={(e) => {
                    var btns = document.getElementsByName(this.props.id)[0].getElementsByClassName('change-buttonts')[0];
                    btns.style.visibility = 'hidden';
                    btns.style.opacity = 0;
                }}

                id='moved-block' className='higlighted__parentElem' data-content='Logo' style={{
                    paddingTop: this.getPaddingTop(), paddingBottom: this.getPaddingBottom(),
                    border: this.props.selectedElm == this.props.id ? '2px solid #34b9a0' : '',
                    paddingLeft: this.getPaddingLeft(), paddingRight: this.getPaddingRight(),
                    backgroundColor: this.getBackgroundColor(),
                    marginTop: this.getMarginTop(), marginBottom: this.getMarginBottom(), marginLeft: this.getMarginLeft(),
                    marginRight: this.getMarginRight(),
                }} onClick={(e) => e.target.tagName === "TD" ? this.props.putElm({ id: this.props.id, type: this.props.type }) : null}>
                {this.renderBlock(this.getType())}
                <div className='change-buttonts' style={{ position: 'absolute', zIndex: 1, top: '8px', right: 32, visibility: 'hidden', opacity: '0', transition: '0.3s all' }}>
                    <img onClick={() => this.styleBack()} Style="cursor: pointer;background: #e6e6e68a;border-radius: 100%;margin-right: 16px;" src="https://adbotest.digitum.nl/static/media/ai_back.svg" />
                    <img onClick={() => this.styleForward()} Style="cursor: pointer;background: #e6e6e68a;border-radius: 100%;" src="https://adbotest.digitum.nl/static/media/ai_forward.svg" />
                </div>
                <Menu
                    parent
                    edit={this.editBlock}
                    canInteract={this.checkIfCanInteract()}
                    delete={this.deleteBlock}
                    copy={this.copyBlock}
                    moveUp={() => this.elemMove('up')}
                    moveDown={() => this.elemMove('down')}
                />
            </Row>
        );
    }

}


function matchDispatchToProps(dispatch) {
    return bindActionCreators({ putElm: putElm, setArr: setArr }, dispatch);
}
const mapStateToProps = state => {
    return {
        arr: state.arr,
        selectedElm: state.selectedElm
    }
}

export default connect(mapStateToProps, matchDispatchToProps)(LogoAIBlock);